module.exports = __webpack_public_path__ + "img/tnt.e3bf261a.svg";